export enum EColorsRGBA {
  PURPLE_800 = 'rgba(51, 42, 124, 1)',
  ORANGE_400 = 'rgba(255, 160, 0, 1)',
  BLUE_GRAY_400 = 'rgba(170, 173, 200, 1)',
  BLUE_GRAY_350 = 'rgba(227, 228, 238, 1)',
}
